import { Fragment } from 'react';
import PrimaryAsyncSelect from '../../PrimaryAsyncSelect';
import PrimaryInputPassword from '../../PrimaryInputPassword';

import { Form, Image } from 'react-bootstrap';
import { loadDepartments, loadJobs } from '../../../api/users';
import PrimarySwitch from '../../PrimarySwitch';

const UserForm = ({
  form,
  handleChange,
  handleFileUpload,
  showPassword,
  checkStatus,
  isChecked,
  emailOtp,
  smsOtp,
  onChangeSms,
  onChangeEmail,
}) => {
  console.log({ form });
  return (
    <Fragment>
      <div className="card-body">
        <div className="form-group">
          <label className="form-label">
            Username <span className="req">*</span>
          </label>

          <input
            id="username"
            className="form-control"
            name="username"
            type="text"
            value={form.username}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Employee No. <span className="req">*</span>
          </label>

          <input
            id="employee_no"
            className="form-control"
            name="employee_no"
            type="text"
            value={form.employee_no}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Last Name <span className="req">*</span>
          </label>

          <input
            className="form-control"
            name="last_name"
            id="last_name"
            type="text"
            value={form.last_name}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            First Name <span className="req">*</span>
          </label>

          <input
            className="form-control"
            name="first_name"
            id="first_name"
            type="text"
            value={form.first_name}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>

        <div className="form-group">
          <div className="row">
            <div className="col-sm-4">
              <label className="form-label">
                Enable/disable otp via email/sms
              </label>
              <PrimarySwitch
                className="text-right mt-3"
                name="is_otp"
                value={form.is_otp}
                checked={form.is_otp ? true : isChecked}
                onChange={checkStatus}
              />
            </div>
            <div className="col-sm-8">
              {isChecked || form.is_otp ? (
                <div className="">
                  <label className="form-label">
                    Send otp via email or sms{' '}
                    {/* <p className="text-danger">(Only 1 is acceptable)</p> */}
                  </label>
                  <div className="row mt-3">
                    <div className="col-sm-3">
                      <label className="form-label">Email</label>
                    </div>
                    <div className="col-sm-9">
                      <PrimarySwitch
                        className="text-right"
                        name="otp_via"
                        value={form.otp_via}
                        checked={
                          form.email && form.otp_via === 'email'
                            ? true
                            : emailOtp
                        }
                        onChange={onChangeEmail}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <label className="form-label">SMS</label>
                    </div>
                    <div className="col-sm-9">
                      <PrimarySwitch
                        className="text-right"
                        name="otp_via"
                        value={form.otp_via}
                        checked={
                          form.contact_no && form.otp_via === 'sms'
                            ? true
                            : smsOtp
                        }
                        onChange={onChangeSms}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">
            Email <span className="req">*</span>
          </label>

          <input
            className="form-control"
            name="email"
            id="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>

        {showPassword && (
          <div className="form-group">
            <label className="form-label">
              Password <span className="req">*</span>
            </label>

            <PrimaryInputPassword
              autocomplete="off"
              onChange={handleChange}
              required={true}
              tabIndex=""
              placeholder="Password"
              id="password"
              name="password"
            />
          </div>
        )}

        <div className="form-group">
          <label className="form-label">
            Department <span className="req">*</span>
          </label>

          <PrimaryAsyncSelect
            onChange={(e) =>
              handleChange({
                target: { name: 'department_id', value: e.value },
              })
            }
            customFunction={loadDepartments}
            name="department_id"
            value={form.department_id}
            isClearable={true}
            config={{
              searchField: 'department_name',
              valueField: 'department_id',
              labelField: 'department_name',
            }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Job <span className="req">*</span>
          </label>

          <PrimaryAsyncSelect
            onChange={(e) =>
              handleChange({
                target: { name: 'job_id', value: e.value },
              })
            }
            customFunction={loadJobs}
            isClearable={true}
            name={'job_id'}
            value={form.job_id}
            config={{
              searchField: 'job_name',
              valueField: 'job_id',
              labelField: 'job_name',
            }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Contact Number <span className="req">*</span>
          </label>

          <input
            className="form-control"
            name="contact_no"
            id="contact_no"
            type="text"
            value={form.contact_no}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Signature</label>
          <Form.Control
            type="file"
            name="signature"
            onChange={handleFileUpload}
          />
        </div>

        {form.signature_file_path !== '' ? (
          <Image src={form.signature_file_path} thumbnail />
        ) : (
          ''
        )}
      </div>
    </Fragment>
  );
};

export default UserForm;
